import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import AliceCarousel from "react-alice-carousel";
import "./cancellation.css";

function Cancellation(props) {
  const [errorMessage, setErrorMessage] = useState("");
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const axiosOptions = {
      url: process.env.REACT_APP_API_URL + "v1/guest/list-book",
      method: "get",
      headers: {
        Accept: "application/json",
        // Authorization: `Bearer ${token}`,
      },
    };

    axios(axiosOptions)
      .then((response) => {
        console.log(response.data.data);
        setData(response.data.data);
        setLoader(false);
      })
      .catch((err) => {
        // console.log(err.response.data.message);
        setLoader(false);
        if (err.response.status === 404) {
          setErrorMessage(err.response.data.message);
        }
      });
  }, []);

  const handleDragStart = (e) => e.preventDefault();
  const images = data.map((img) => {
    // const img = props.images
    return (
      <div className="item" key={img.id}>
        <Link to={`/book-detail/${img.book_code}`}>
          <img
            src={img.image_path}
            onDragStart={handleDragStart}
            role="presentation"
            height="250"
            width="150"
          />
        </Link>
      </div>
    );
  });

  // console.log(images)
  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
  };

  const Carousel = () => (
    <AliceCarousel
      mouseTracking
      items={images}
      responsive={responsive}
      controlsStrategy="alternate"
    />
  );

  return (
    <div className="container">
      <div style={{ marginTop: "140px" }}>
        <h1>
          By cancelling, you will lose your audio credits and subscriber
          benefits.
        </h1>
        <br />
        <br />
        <br />
        <br />
        <h1> Would you like to take a break instead? </h1>
        <br />
        <br />
        <p>
          You could pause your subscription to take the time to spend your audio
          credits
        </p>
        <Link className="btn btn-dark w-150px" to={`/account/takebreak`}>
          Take a break
        </Link>

        <h1>Novels available:</h1>
        <Carousel />
      </div>
      <div className="row">
        <div className="col-4">
          <Link className="btn btn-dark w-125px" to={`/user/welcome`}>
            Use Credits
          </Link>
        </div>
        <div className="col-8">
          {/* <Link
            className="btn btn-outline-dark"
            to={`/account/cancellation/showoffer`}
            style={{ border: "2px solid #000" }}
          >
            Continue Cancellation
          </Link> */}

          <Link
            className="btn btn-outline-dark ms-18"
            to={`/account/cancellation/reason`}
            style={{ border: "2px solid #000" }}
          >
            Continue Cancellation
          </Link>
        </div>
        {/* <div className="col-4"></div> */}
      </div>
    </div>
  );
}

export default Cancellation;
